<template>
    <div class="vue-circle-progress"
         :class="{ 'is-loading': loading }"
         :style="{
         width: size + 'px', height: size + 'px',
         }">
        <svg :viewBox="`0 0 ${size} ${size}`" style="transform: rotate(-90deg);">
            <!-- 背景圆环 -->
            <circle
                    :cx="size/2"
                    :cy="size/2"
                    :r="radius"
                    fill="none"
                    :stroke="bgColor"
                    :stroke-width="strokeWidth"
            />
            <!-- 进度圆环 -->
            <circle
                    :cx="size/2"
                    :cy="size/2"
                    :r="radius"
                    fill="none"
                    :stroke="loading? '#ccc': progressColor"
                    :stroke-width="strokeWidth"
                    :stroke-dasharray="circumference"
                    :stroke-dashoffset="dashOffset"
                    stroke-linecap="round"
            />
        </svg>
        <div class="circle-content" :style="{ fontSize: size * 0.2 + 'px' }">
            <slot name="format"></slot>
        </div>
    </div>
</template>

<script setup>
    import { computed, defineProps} from 'vue';

    const props = defineProps({
        progress: { type: Number, default: 0 }, // 0-100
        size: { type: Number, default: 120 },
        strokeWidth: { type: Number, default: 1 },
        bgColor: { type: String, default: '#f0f0f0' },
        progressColor: { type: String, default: '#1890ff' },
        loading: { type: Boolean, default: true }
    });

    const radius = computed(() => (props.size - props.strokeWidth) / 2);
    const circumference = computed(() => 2 * Math.PI * radius.value);
    const dashOffset = computed(() => {
        return circumference.value * (1 - props.progress / 100);
    });
</script>

<style scoped>
    .vue-circle-progress {
        position: relative;
        display: inline-block;
    }

    .vue-circle-progress svg {
        width: 100%;
        height: 100%;
        display: block;
    }

    .circle-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: bold;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
</style>